export default __webpack_public_path__ + "static/media/DEPARIS_02.cec393d9.gif";